import { apiFetch } from '../config/api'

export interface PassNameMappingItem {
  id: number
  rawPassName: string
  canonicalPassName: string
  usageCount: number
  isPreferred: boolean
  lastUsedAt: string
}

export interface PassNameMappingGroup {
  rawPassName: string
  activeMappingId: number | null
  mappings: PassNameMappingItem[]
}

export async function fetchPassMappingSuggestions(input: {
  rawPassNames: string[]
  wpsPassLabels: string[]
}): Promise<Record<string, string>> {
  const result = await apiFetch<{ suggestions: Record<string, string> }>(
    '/api/pass-name-mappings/suggest',
    {
      method: 'POST',
      body: JSON.stringify({
        rawPassNames: input.rawPassNames,
        wpsPassLabels: input.wpsPassLabels
      })
    }
  )
  return result.suggestions ?? {}
}

export async function listPassNameMappingsGrouped(input?: {
  search?: string
}): Promise<{ groups: PassNameMappingGroup[] }> {
  const q = input?.search?.trim() ? `?search=${encodeURIComponent(input.search.trim())}` : ''
  return apiFetch<{ groups: PassNameMappingGroup[] }>(
    `/api/pass-name-mappings/admin-grouped${q}`
  )
}

export async function createPassNameMappingAdmin(input: {
  rawPassName: string
  canonicalPassName: string
  setPreferred?: boolean
}): Promise<PassNameMappingItem> {
  const result = await apiFetch<{ item: PassNameMappingItem }>('/api/pass-name-mappings/admin', {
    method: 'POST',
    body: JSON.stringify(input)
  })
  return result.item
}

export async function updatePassNameMapping(
  id: number,
  patch: { canonicalPassName?: string; usageCount?: number }
): Promise<PassNameMappingItem> {
  const result = await apiFetch<{ item: PassNameMappingItem }>(
    `/api/pass-name-mappings/${id}`,
    {
      method: 'PATCH',
      body: JSON.stringify(patch)
    }
  )
  return result.item
}

export async function promotePassNameMapping(id: number): Promise<PassNameMappingItem> {
  const result = await apiFetch<{ item: PassNameMappingItem }>(
    `/api/pass-name-mappings/${id}/promote`,
    { method: 'POST' }
  )
  return result.item
}

export async function deletePassNameMapping(id: number): Promise<void> {
  await apiFetch(`/api/pass-name-mappings/${id}`, { method: 'DELETE' })
}
